
let mathQuadricEven = (length, median, value) => {
    let lambda = Math.log(0.5) / median;
    let endpoint = 1 - Math.exp(lambda);
    return (1 - Math.exp(value / length * lambda)) / endpoint;
}

let mathQuadricFair = (length, median, value) => {
    let lambda = Math.log(0.5) / median;
    let endpoint = 1 - Math.exp(lambda);
    return Math.sqrt(1 - Math.exp(value / length * lambda)) / endpoint;
}

var AxisDistortion = {
    apply: (settings, range, val) => {
        if(settings.kernel === 'exp.fair')
            return mathQuadricFair(range[1], settings.median, val);
        else if(settings.kernel === 'exp.even')
            return mathQuadricEven(range[1], settings.median, val);
        else
            return val;
    }
}

export default AxisDistortion;